export default __webpack_public_path__ + "static/media/delete-icon.bf76a09f.svg";